module.exports = __webpack_public_path__ + "img/platoCombinado.e9e05671.png";